import { render, staticRenderFns } from "./criteria-input.vue?vue&type=template&id=5ee4108e&scoped=true&"
import script from "./criteria-input.vue?vue&type=script&lang=js&"
export * from "./criteria-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee4108e",
  null
  
)

export default component.exports